import React, { useState, useRef, useEffect } from "react"
import { getRequest, pathname } from "@react/helpers/fetch"
import Input from "@react/shared/ui/Input"

const SEARCH_PATH = "/quotes/qline_service_blueprints/search"

const ComponentPicker = ({ excludeId, onSelect, placeholder, size = "md" }) => {
  const [query,   setQuery]   = useState("")
  const [results, setResults] = useState([])
  const [open,    setOpen]    = useState(false)

  const wrapperRef   = useRef(null)
  const debounceRef  = useRef(null)
  const requestIdRef = useRef(0)

  useEffect(() => {
    const handleClickOutside = event => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) setOpen(false)
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  const runSearch = value => {
    setQuery(value)
    clearTimeout(debounceRef.current)
    if (!value || value.trim().length < 2) {
      setResults([])
      setOpen(false)
      return
    }
    debounceRef.current = setTimeout(() => {
      const requestId = ++requestIdRef.current
      const params    = { q: value.trim() }
      if (excludeId) params.for_composition_of = excludeId
      getRequest(pathname({ path: SEARCH_PATH, format: "json", params }))
        .then(data => {
          if (requestId !== requestIdRef.current) return
          setResults(Array.isArray(data) ? data : [])
          setOpen(true)
        })
        .catch(() => {
          if (requestId !== requestIdRef.current) return
          setResults([])
          setOpen(false)
          flashAlert(I18n.t("quotes.qline_service_blueprints.index.network_error"))
        })
    }, 250)
  }

  const choose = blueprint => {
    setOpen(false)
    setQuery("")
    setResults([])
    onSelect(blueprint)
  }

  return (
    <div ref={wrapperRef} className="relative">
      <Input
        variant     = "search"
        size        = {size}
        leadingIcon = "sitemap"
        value       = {query}
        placeholder = {placeholder || I18n.t("quotes.qline_service_blueprints.form.component_search_placeholder")}
        onChange    = {e => runSearch(e.target.value)}
        onFocus     = {() => { if (results.length) setOpen(true) }}
      />
      {open && results.length > 0 && (
        <ul className="absolute z-50 mt-1 w-full max-h-64 overflow-auto rounded-md border border-slate-200 bg-white shadow-lg py-1 text-sm">
          {results.map(blueprint => (
            <li key={blueprint.id}>
              <button
                type        = "button"
                onMouseDown = {event => { event.preventDefault(); choose(blueprint) }}
                className   = "w-full text-left px-3 py-2 hover:bg-brand-50 text-slate-700 flex items-center justify-between gap-2"
              >
                <span className="truncate">{blueprint.name}</span>
                <span className="shrink-0 tabular-nums text-slate-400 text-xs">
                  {(blueprint.sale_cents / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2 })} {blueprint.currency_symbol}
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
      {open && results.length === 0 && query.trim().length >= 2 && (
        <div className="absolute z-50 mt-1 w-full rounded-md border border-slate-200 bg-white shadow-lg px-3 py-2 text-sm text-slate-500">
          {I18n.t("quotes.qline_service_blueprints.form.component_no_results")}
        </div>
      )}
    </div>
  )
}

export default ComponentPicker
